// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1BSsY","txt":"Menu_txt__1aVAv","menu_slider":"Menu_menu_slider__rQ1DV","img_wrapper":"Menu_img_wrapper__1dnf3","slide_menu":"Menu_slide_menu__3xlfb"};